<template>
  <div class="page-container">
    <!-- Content Wrapper START -->
    <div class="main-content">
      <div class="page-header">
        <h2 class="header-title">Categories</h2>
        <div class="header-sub-title">
          <nav class="breadcrumb breadcrumb-dash">
            <router-link :to="`/`" class="breadcrumb-item">
              <i class="anticon anticon-home m-r-5"></i>Home
            </router-link>
            <span class="breadcrumb-item active">Categories</span>
          </nav>
        </div>
      </div>
      <div class="card">
        <div class="card-body">
          <div class="m-t-25">
            <div class="row">
              <div class="col-lg-12 add-form mb-4 d-flex justify-content-end">
                <button class="btn btn-info" data-toggle="modal" data-target="#modal">Add New Category</button>
              </div>
            </div>
            <section v-if="!isLoading">
              <div class="row">
                <div class="col-lg-12 add-form">
                  <input class="form-control datatable_search" @keyup="searchDatatable" placeholder="Search..."/>
                </div>
              </div>
              <table class="dataTable table">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Enabled</th>
                    <th>Menu Top</th>
                    <th>Sort #</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="category in categories" :key="category.id">
                    <td>{{category.name}}</td>
                    <td class="checkbox-icon pt-0 disabled-click">
                      <label class="checkbox-container">
                        <input :checked="category.is_enabled" type="checkbox">
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="checkbox-icon pt-0 disabled-click">
                      <label class="checkbox-container">
                        <input :checked="category.is_menu_top" type="checkbox">
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td>{{category.sort_no}}</td>
                    <td>
                      <i class="fa fa-trash fa-icons" @click="deleteCategory(category.id)" aria-hidden="true"></i>
                      <i class="fa fa-pencil-alt fa-icons ml-md-3" aria-hidden="true" @click="editedCategory = JSON.parse(JSON.stringify(category))" data-toggle="modal" data-target="#edit-modal"></i>
                    </td>
                  </tr>
                </tbody>
                <tfoot></tfoot>
              </table>
            </section>
            <div class="main-loader" v-else>
              <MainLoader></MainLoader>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Content Wrapper END -->
    <CategoryModal></CategoryModal>
    <EditCategoryModal v-if="editedCategory" :category="editedCategory" :key="editedCategory.id"></EditCategoryModal>
  </div>
</template>

<script>
/* eslint-disable no-undef */
import CategoryModal from '@/components/CategoryModal'
import EditCategoryModal from '@/components/EditCategoryModal'
import Category from '@/models/Category'
export default {
  name: 'Categories',
  components: {
    CategoryModal,
    EditCategoryModal
  },
  data () {
    return {
      datatable: null,
      categories: [],
      editedCategory: null
    }
  },
  computed: {
    isLoading () {
      if (this.categories.length === 0) { return this.$store.getters.apiStatus === 'loading' } else return false
    }
  },
  mounted () {
    let dataTableScript = document.createElement('script')
    dataTableScript.setAttribute('src', 'https://cdn.datatables.net/1.10.22/js/jquery.dataTables.min.js')
    document.head.appendChild(dataTableScript)
    this.fetchAllCategories()
  },
  methods: {
    fetchAllCategories () {
      this.categories = []
      this.$store.dispatch('fetchAllCategories')
        .then((result) => {
          result.data.categories.forEach(category => {
            this.categories.push(new Category(category))
          })
          setTimeout(() => this.initDatatables(), 100)
        })
        .catch((err) => this.$helper.catchHandler(err))
    },
    deleteCategory (id) {
      this.$confirm(
        {
          message: `Are you sure you want to delete this category?`,
          button: { no: 'No', yes: 'Yes' },
          callback: confirm => {
            if (confirm) {
              this.$store.dispatch('deleteCategory', id)
                .then((result) => {
                  this.$toast.success(result.data.message)
                  this.fetchAllCategories()
                })
                .catch((err) => this.$toast.error(err.response.data.message))
            }
          }
        }
      )
    },
    searchDatatable (e) {
      this.datatable.search(e.target.value).draw()
    },
    initDatatables () {
      this.datatable = $('table').DataTable({
        destroy: true,
        stateSave: true,
        pagingType: 'full_numbers',
        columnDefs: [{
          targets: 4,
          'orderable': false
        }],
        stateSaveCallback: function (settings, data) {
          localStorage.setItem('DataTables_accounts_page', JSON.stringify(data))
        },
        stateLoadCallback: function (settings) {
          return JSON.parse(localStorage.getItem('DataTables_accounts_page'))
        },
        drawCallback: function (settings) {
          $('.previous').html("<img src='/static/images/left_arrow.svg'>")
          $('.next').html("<img src='/static/images/right_arrow.svg'>")
          $('.first').addClass('d-inline')
          $('.first').html("<img src='/static/images/left_arrow.svg'><img src='/static/images/left_arrow.svg'>")
          $('.last').addClass('d-inline')
          $('.last').html("<img src='/static/images/right_arrow.svg'><img src='/static/images/right_arrow.svg'>")
        }
      })
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/Categories.vue